import {Component, Material, Object3D, TextComponent} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {BoardColor} from './board-object.js';
import {ScoreController} from './score-controller.js';
import {FXPrefabs} from './fx-prefabs.js';
import {vec3} from 'gl-matrix';
import {WLUtils} from '../utils/WLUtils.js';
import {formatNumber} from '../utils/Utils.js';
import {Localization} from '../utils/Localization.js';

const tempVec = vec3.create();

export class SpawnScoreAfterSeconds extends Component {
    static TypeName = 'spawn-score-after-seconds';

    @property.string('')
    scoreTextPrefab = '';

    //TK: This is not needed at the moment. Probably with more advaced powerups or something
    // we need this...
    // @property.object({required: true})
    // mainTextObject!: Object3D;

    @property.float(1)
    timeToSpawnText = 1;

    @property.material()
    textMaterial?: Material;

    private _time: number = 0;
    private _spawned: boolean;
    private _scoreParent: Object3D;
    private _mainText: TextComponent;
    _score: number;
    private _material: Material;
    private _text: string;

    init() {
        this.active = false; // deactive itself to prevent it from running until activated
    }

    start() {
        this._mainText = this.object.getComponent(TextComponent);
    }

    update(dt: number) {
        this._time += dt;
        if (this._time > this.timeToSpawnText && !this._spawned) {
            ScoreController.instance.addScore(this._score, false);
            const scoreFX = FXPrefabs.instance.spawn(
                this.scoreTextPrefab,
                this._scoreParent
            );
            this.object.getPositionWorld(tempVec);
            scoreFX.setPositionWorld(tempVec);
            const scoreFxText = scoreFX.getComponent(TextComponent);
            scoreFxText.material = this._material;

            if (scoreFxText) {
                scoreFxText.text = '+' + formatNumber(this._score);
            }
            WLUtils.setActive(scoreFX, true);

            this._spawned = true;
        }
    }

    setTextOfThis(text: string) {
        if (!this._mainText) {
            this._mainText = this.object.getComponent(TextComponent);
        }
        this._mainText.text = Localization.instance.get(text);
    }

    setScoreToShow(scoreAmount: number) {
        //TK: Not sure how to handle this yet. Some parts seems to do something with the score
        // but we have not reached those yet.
        this._score = scoreAmount;
        // int roundedGoal = Mathf.CeilToInt(scoreAmount);

        // score = (roundedGoal - (roundedGoal % 1000));
    }

    // setScoreToShow(scoreAmount:number)
    // {
    // 	score = scoreAmount;

    // }

    setParent(theParent: Object3D) {
        this._scoreParent = theParent;
    }

    setColor(col: BoardColor) {
        if (!this._mainText) {
            this._mainText = this.object.getComponent(TextComponent);
        }

        this._material = ScoreController.instance.boardColorToMaterial(
            //this._mainText.material = ScoreController.instance.boardColorToMaterial(
            col,
            this.textMaterial
        );

        this._mainText.material = this._material;
    }
}
